import Hero from "../Hero";
import MySkills from "../MySkills";
import Projects from "../Projects";
import Contact from "../Contact";

export default function Home() {
    return (
        <>
            <Hero />
            <MySkills />
            <Projects />
            <Contact />
        </>
    ) 
}